// extracted by mini-css-extract-plugin
export var card = "TileCollection-module--card--0678d";
export var mobile = "TileCollection-module--mobile--63ba2";
export var mobileSlider = "TileCollection-module--mobileSlider--b6e02";
export var tilesCollectionContainer = "TileCollection-module--tilesCollectionContainer--fe26f";
export var tilesCollectionPan = "TileCollection-module--tilesCollectionPan--6519d";
export var tilesCollectionTitle = "TileCollection-module--tilesCollectionTitle--a9e59";
export var tilesCollectionWrapper = "TileCollection-module--tilesCollectionWrapper--ddb34";
export var tilesCollectionWrapperCommon = "TileCollection-module--tilesCollectionWrapperCommon--71648";